<template>
  <div id="app">
    <el-container>
      <a v-if="showSiteChrome" class="skip-link" href="#main-content">跳到正文</a>
      <el-header v-if="showSiteChrome" class="site-header">
        <router-link class="brand" to="/" :aria-label="`${globalContent.brandName}首页`">
          <img :src="globalContent.brandLogo" :alt="globalContent.brandName" />
        </router-link>
        <el-menu
          :default-active="$route.path"
          class="site-menu"
          mode="horizontal"
          :router="true"
        >
          <el-menu-item index="/">{{ globalContent.navHome }}</el-menu-item>
          <el-menu-item index="/product">{{ globalContent.navNavigation }}</el-menu-item>
          <el-menu-item index="/case">{{ globalContent.navProduct }}</el-menu-item>
          <el-menu-item index="/news">{{ globalContent.navService }}</el-menu-item>
          <el-menu-item index="/goin">{{ globalContent.navAbout }}</el-menu-item>
          <el-menu-item index="/download" class="contact-menu">{{ globalContent.navContact }}</el-menu-item>
        </el-menu>
      </el-header>

      <el-main id="main-content">
        <router-view />
      </el-main>

      <footer v-if="showSiteChrome" class="site-footer">
        <div class="footer-content">
          <div class="footer-brand">
            <img :src="globalContent.brandLogo" :alt="globalContent.brandName" />
            <p>{{ globalContent.footerSlogan }}</p>
            <p class="muted">{{ globalContent.footerSubline }}</p>
          </div>
          <div class="footer-links">
            <p class="footer-title">{{ globalContent.footerNavTitle }}</p>
            <router-link to="/product">{{ globalContent.navNavigation }}</router-link>
            <router-link to="/case">{{ globalContent.navProduct }}</router-link>
            <router-link to="/goin">{{ globalContent.navAbout }}</router-link>
          </div>
          <div class="footer-contact">
            <p class="footer-title">{{ globalContent.footerContactTitle }}</p>
            <a :href="`tel:${contactContent.phone}`">电话：{{ contactContent.phone }}</a>
            <span>微信：{{ contactContent.wechat }}</span>
            <a :href="`mailto:${contactContent.email}`">邮箱：{{ contactContent.email }}</a>
          </div>
          <div class="footer-qr">
            <img :src="contactContent.qrImage" :alt="`${globalContent.brandName}企业微信二维码`" />
            <span>{{ globalContent.qrCaption }}</span>
          </div>
        </div>
        <div class="copyright">
          <span>© {{ currentYear }} {{ globalContent.copyright }}</span>
          <a
            :href="globalContent.icpUrl"
            target="_blank"
            rel="noopener noreferrer"
          >{{ globalContent.icpNumber }}</a>
        </div>
      </footer>
    </el-container>
  </div>
</template>

<script>
import { loadSiteContent } from "./site-content";
import { getSiteContentDefaults } from "./site-content-config";

export default {
  data() {
    return {
      globalContent: getSiteContentDefaults("global"),
      contactContent: getSiteContentDefaults("contact")
    };
  },
  mounted() {
    loadSiteContent(this, "site.global", this.globalContent).then(content => { this.globalContent = content; });
    loadSiteContent(this, "site.contact", this.contactContent).then(content => { this.contactContent = content; });
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    showSiteChrome() {
      return this.$route.path.indexOf("/admin") !== 0 && this.$route.path !== "/login";
    }
  }
};
</script>

<style lang="scss">
:root {
  --brand-blue: #3157c8;
  --brand-purple: #7046c8;
  --brand-ink: #172033;
  --brand-muted: #64748b;
  --brand-soft: #f4f7ff;
}

* { box-sizing: border-box; padding: 0; margin: 0; }
html, body { min-height: 100%; }
body { background: #fff; overflow-x: hidden; }
a { color: inherit; }
a:focus-visible, button:focus-visible, input:focus-visible { outline: 3px solid #8ca5ff; outline-offset: 3px; }
.skip-link { position: fixed; left: 16px; top: -60px; z-index: 2000; padding: 10px 16px; border-radius: 6px; color: #fff; text-decoration: none; background: #172033; transition: top .2s; }
.skip-link:focus { top: 12px; }

#app {
  min-height: 100vh;
  font-family: "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--brand-ink);
}

.el-container { min-height: 100vh; min-width: 0; }
.el-main { padding: 0 !important; overflow: visible !important; }

.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 74px !important;
  padding: 0 max(24px, calc((100vw - 1200px) / 2)) !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255,255,255,.96);
  border-bottom: 1px solid #e8edf7;
  box-shadow: 0 4px 18px rgba(38,58,104,.06);
  backdrop-filter: blur(12px);
}

.brand { display: flex; align-items: center; width: 188px; height: 62px; overflow: hidden; }
.brand img { width: 100%; height: 100%; object-fit: contain; }
.site-menu { border-bottom: 0 !important; background: transparent !important; }
.site-menu.el-menu--horizontal > .el-menu-item {
  height: 74px;
  line-height: 74px;
  color: #334155;
  font-size: 15px;
  padding: 0 18px;
}
.site-menu.el-menu--horizontal > .el-menu-item:hover,
.site-menu.el-menu--horizontal > .el-menu-item.is-active {
  color: var(--brand-blue) !important;
  border-bottom-color: var(--brand-blue) !important;
  background: transparent !important;
}
.site-menu .contact-menu { font-weight: 700; }

.site-footer { background: #121a2d; color: #fff; }
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 52px 24px 38px;
  display: grid;
  grid-template-columns: 1.5fr .7fr 1fr 150px;
  gap: 44px;
  align-items: start;
}
.footer-brand > img { width: 190px; height: 74px; object-fit: contain; background: #fff; border-radius: 12px; padding: 4px; }
.footer-brand p { margin-top: 12px; font-size: 16px; }
.footer-brand .muted { color: #9facbf; font-size: 14px; }
.footer-title { margin-bottom: 14px; font-size: 16px; font-weight: 700; }
.footer-links, .footer-contact { display: flex; flex-direction: column; gap: 11px; }
.footer-links a, .footer-contact a, .footer-contact span { color: #b9c3d5; font-size: 14px; text-decoration: none; }
.footer-links a:hover, .footer-contact a:hover { color: #fff; }
.footer-qr { display: flex; flex-direction: column; align-items: center; gap: 8px; color: #b9c3d5; font-size: 12px; }
.footer-qr img { width: 126px; height: 132px; object-fit: cover; background: #fff; padding: 5px; border-radius: 10px; }
.copyright { padding: 16px 24px; display: flex; justify-content: center; align-items: center; gap: 16px; flex-wrap: wrap; text-align: center; color: #8995aa; font-size: 13px; border-top: 1px solid #263047; }
.copyright a { color: #aab4c7; text-decoration: none; transition: color .2s; }
.copyright a:hover { color: #fff; text-decoration: underline; }

@media (max-width: 900px) {
  .site-header { height: auto !important; min-height: 68px; padding: 6px 16px !important; align-items: flex-start; }
  .brand { width: 142px; height: 55px; flex: 0 0 auto; }
  .site-menu { display: flex; overflow-x: auto; }
  .site-menu.el-menu--horizontal > .el-menu-item { height: 56px; line-height: 56px; padding: 0 11px; font-size: 14px; white-space: nowrap; }
  .footer-content { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 600px) {
  .site-header { position: relative; flex-direction: column; align-items: center; }
  .site-menu { width: 100%; display: flex; flex-wrap: wrap; justify-content: center; overflow: visible; }
  .site-menu.el-menu--horizontal > .el-menu-item { width: 33.333%; height: 44px; line-height: 44px; padding: 0 4px; text-align: center; }
  .footer-content { grid-template-columns: 1fr; text-align: center; gap: 28px; }
  .footer-links, .footer-contact, .footer-brand { align-items: center; }
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after { scroll-behavior: auto !important; transition-duration: .01ms !important; animation-duration: .01ms !important; }
}
</style>
